'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerActionsList = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.isLoaded = isLoaded;
exports.default = customerByEmail;
exports.loadIfNeeded = loadIfNeeded;

var _cameras = require('./cameras');

var _reduxUtils = require('../reduxUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Needs serious revamp.
 *
 * This file currently mixes both the camera and customer models
 * Instead this should just reference the camera model
 */

// TODO: This is a bad issue - but unavoidable without some rearch because cameras *can*
// load the user and users always load all associated cameras
// eslint-disable-next-line import/no-cycle
var BASE_CUSTOMER_ACTION = 'customer';

function isLoaded(globalState) {
  return globalState.customers && globalState.customers.loaded;
}

var customerActionsList = exports.customerActionsList = {
  root: {
    getPath: function getPath(email) {
      return '/django/users/' + email + '/cameras/';
    },
    getObject: function getObject(state, email) {
      return state.customers[email];
    }
  },
  zendesk: {
    getPath: function getPath(email) {
      return '/zendesk/search.json?query=requester:' + email + '%20type:ticket';
    }
  },
  subscription: {
    getPath: function getPath(email) {
      return '/django/users/' + email + '/';
    }
  }
};

var onLoadPromise = function onLoadPromise(dispatch, email) {
  return function (response) {
    if (response.results && response.results.map) {
      response.results.map(function (camera) {
        return (0, _cameras.fetchRelevantCameraInfo)(camera, dispatch);
      });
    }
    dispatch(customerActionsList.zendesk.dispatchFunction(email));
    dispatch((0, _reduxUtils.loadIfNeeded)(email, customerActionsList.subscription));
    return response;
  };
};

customerActionsList.root.promise = onLoadPromise;

(0, _reduxUtils.fillActionsListWithActions)(BASE_CUSTOMER_ACTION, customerActionsList);

var initialState = (0, _reduxUtils.getInitialState)(customerActionsList);

function customer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case customerActionsList.root.actions[0]:
      // Load start
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case customerActionsList.root.actions[1]:
      // Load success
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        email: action.email,
        cameras: action.result.results.reverse().map(function (camera) {
          return camera.serial_number;
        })
      });
    case customerActionsList.root.actions[2]:
      // Load fail
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return (0, _reduxUtils.defaultProcessingOfActions)(state, action, customerActionsList);
  }
}

function customerByEmail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return (0, _reduxUtils.defaultLoadSubField)(state, action, BASE_CUSTOMER_ACTION, customer);
}

function loadIfNeeded(email) {
  var subQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : customerActionsList.root;

  return (0, _reduxUtils.loadIfNeeded)(email.toLowerCase(), subQuery);
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/customers.js
 ** module id = 217
 ** module chunks = 0
 **/